<template>
  <div class="xcard">
    <v-toolbar-title class="mb-5 py-2" style="border-bottom: 1px solid #d4dbe0">
      <div class="d-flex flex-wrap justify-space-between align-center">
        <span>INGRESOS PROYECTADOS GESTION ANTERIOR</span>

        <div style="max-width: 200px">
          <v-select
            :items="gestiones"
            label="Gestion"
            item-text="numero"
            item-value="id"
            v-model="gestionId"
            @input="setGestionId"
            placeholder=" "
            outlined
            dense
            hide-details />
        </div>
      </div>
    </v-toolbar-title>

    <v-row>
      <v-col cols="12" md="9" xl="10" class="pa-2 pb-0">
        <v-btn
          v-if="permisosPresupuestos2 && !permisosPresupuestos3"
          :disabled="registrandoProyeccionesIngresos || proyeccionesIngresosEstanRegistradas || items.length == 0"
          :loading="registrandoProyeccionesIngresos"
          @click="abrirConfirmacion"
          small
          color="primary"
          class="mr-2 my-1"
          :title="titulo">
          <v-icon>mdi-check-all</v-icon>

          {{ titulo }}
        </v-btn>

        <v-btn small class="mr-2 my-1" @click="recargar" title="Recargar">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-col>

      <v-col cols="12" md="3" xl="2" class="pa-2 pb-0">
        <v-text-field
          dense
          outlined
          hide-details
          v-model="searchQuery"
          append-icon="mdi-magnify"
          label="Buscar"
          clearable
          @input="updateSearchQuery"></v-text-field>
      </v-col>

      <v-col cols="12" class="pa-2 pb-4">
        <ListadoPresupuestoProyeccionIngreso ref="listadoRef" :items="items" :cargando="cargando" />
      </v-col>
    </v-row>

    <ConfirmacionMensaje v-bind="{ ...confirmacionMensaje }" @aceptar="aceptarConfirmacionMensaje">
      <router-link to="presupuestos">Ir a Presupuestos</router-link>
    </ConfirmacionMensaje>

    <ConfirmacionAccion
      ref="confirmacionAccionRef"
      v-bind="{ ...confirmacion }"
      :realizandoAccion="registrandoProyeccionesIngresos"
      @aceptar="registrarProyeccionesDeIngresos" />

    <notifications group="notifications" position="top right" />
  </div>
</template>

<script>
import ListadoPresupuestoProyeccionIngreso from '../views/ListadoPresupuestoProyeccionIngreso.vue';
import ProyeccionesIngresosServices from '../services/proyecciones-ingresos';
import ConfirmacionMensaje from '@/components/ConfirmacionMensaje.vue';
import ConfirmacionAccion from '@/components/ConfirmacionAccion.vue';
import PresupuestosServices from '../services/index.js';
import TransaccionesServices from '../services/transaccion.js';
import { categoriasRelacionadasConClasificadores, formatearErrores } from '../utils';
import GetGestionesMixin from '../mixins/get-gestiones-mixin';
import { mapGetters } from 'vuex';

export default {
  name: 'PresupuestoProyectadoIngresos',
  mixins: [GetGestionesMixin],
  components: {
    ListadoPresupuestoProyeccionIngreso,
    ConfirmacionMensaje,
    ConfirmacionAccion,
  },
  computed: {
    ...mapGetters({
      permisosPresupuestos2: 'presupuesto/permisosPresupuestos2',
      permisosPresupuestos3: 'presupuesto/permisosPresupuestos3',
    }),
    titulo() {
      return !this.proyeccionesIngresosEstanRegistradas ? 'Registrar Proyección' : 'Proyección Registrada';
    },
  },
  mounted() {
    this.obtenerGestiones();
  },
  watch: {
    '$store.state.CARGO.sede.id': function (val) {
      if (val && this.gestionId) {
        this.recargar();
      }
    },
    'gestion.numero': {
      handler: function (val) {
        if (val && this.$store.state.CARGO.sede.id) {
          this.recargar();
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      items: [],
      cargando: false,
      searchQuery: '',
      proyeccionesIngresosEstanRegistradas: true,
      registrandoProyeccionesIngresos: false,
      confirmacionMensaje: {
        titulo: 'No se Encuentra Presupuesto',
        mensaje: '',
        mostrado: false,
      },
      confirmacion: {
        titulo: 'Registro de Proyección de Ingresos',
        mensaje: '',
      },
    };
  },
  methods: {
    recargar() {
      this.listar();
      this.verificarPresupuestosProyectados();
    },
    async listar() {
      this.items = [];
      this.cargando = true;

      try {
        const params = {
          sede_id: this.$store.state.CARGO.sede.id,
          fecha_inicio: `${this.gestion?.numero}-01-01`,
          fecha_fin: `${this.gestion?.numero}-12-31`,
          universidad_id: 0,
        };
        const response = await ProyeccionesIngresosServices.get({ params });
        const data = response.data.data;
        const items = data ? data.sort((a, b) => a.programa.programa_id - b.programa.programa_id) : [];
        const nombreMeses = [
          'enero',
          'febrero',
          'marzo',
          'abril',
          'mayo',
          'junio',
          'julio',
          'agosto',
          'septiembre',
          'octubre',
          'noviembre',
          'diciembre',
        ];

        this.items = items.map((item) => {
          const { programa, meses } = item;
          const data = {};
          nombreMeses.forEach((nombreMes) => {
            const mes = meses.find((mes) => mes.nombre === nombreMes);

            if (mes) {
              data[nombreMes] = {
                total: mes.total,
                mes: mes.nombre.charAt(0).toUpperCase() + mes.nombre.slice(1),
                numero_mes: mes.numero,
                tipo: 'ingreso proyectado',
                unidad_id: null,
                detalles_transacciones: mes.categorias.map((categoria) => {
                  const clasificador = categoriasRelacionadasConClasificadores(
                    this.$store.state.CARGO.sede.id,
                    this.gestion?.numero,
                  )[
                    categoria.nombre
                      .toLowerCase()
                      .normalize('NFD')
                      .replace(/[\u0300-\u036f]/g, '')
                  ];

                  return {
                    clasificador_id: clasificador.id,
                    nombre: programa.nombre,
                    costo: categoria.monto,
                    cantidad: 1,
                    debe: 0,
                    haber: categoria.monto,
                    observaciones: null,
                    unidad_medida_id: null,
                    subtotal: categoria.monto,
                    estado: 'Aceptado',
                    remover: 0,
                  };
                }),
              };
            } else {
              data[nombreMes] = {
                total: 0,
                mes: nombreMes.charAt(0).toUpperCase() + nombreMes.slice(1),
                numero_mes: nombreMeses.indexOf(nombreMes) + 1,
                tipo: 'ingreso proyectado',
                unidad_id: null,
                detalles_transacciones: [],
              };
            }
          });

          return {
            programa,
            ...data,
            total: {
              total:
                data.enero.total +
                data.febrero.total +
                data.marzo.total +
                data.abril.total +
                data.mayo.total +
                data.junio.total +
                data.julio.total +
                data.agosto.total +
                data.septiembre.total +
                data.octubre.total +
                data.noviembre.total +
                data.diciembre.total,
            },
          };
        });
      } catch (error) {
        window.console.log(error);
      } finally {
        this.cargando = false;
      }
    },
    aceptarConfirmacionMensaje() {
      this.$refs.confirmacionAccionRef.cerrar();
      this.confirmacionMensaje.mostrado = false;
    },
    async verificarPresupuestosProyectados() {
      try {
        const params = {
          sede_id: this.$store.state.CARGO.sede.id,
          gestion_id: this.gestionId,
        };

        await PresupuestosServices.getWhereSedeIdYGestionIngresosProyectados({ params });

        this.proyeccionesIngresosEstanRegistradas = true;
      } catch (error) {
        window.console.log(error);
        const { mensaje, errores } = error.response.data;
        const erroresFormateados = formatearErrores(errores);

        this.proyeccionesIngresosEstanRegistradas = false;
        this.$notify({
          group: 'notifications',
          title: mensaje,
          text: erroresFormateados,
          type: 'danger',
        });
        this.errores = errores;
      }
    },
    async registrarProyeccionesDeIngresos() {
      this.registrandoProyeccionesIngresos = true;

      try {
        const params = {
          sede_id: this.$store.state.CARGO.sede.id,
          gestion_id: this.gestionId,
        };
        const response = await PresupuestosServices.getWhereSedeIdYGestion({ params });
        const presupuesto = response?.data?.datos;

        const data = [];

        this.items.forEach((item) => {
          Object.keys(item).forEach((key) => {
            if (key != 'total' && key != 'programa') {
              const { detalles_transacciones, ...itemData } = item[key];

              if (detalles_transacciones.length > 0) {
                const indice = data.findIndex((d) => d.mes === itemData.mes);
                const total = detalles_transacciones.reduce((a, b) => a + Number(b.haber), 0);

                if (indice == -1) {
                  data.push({
                    ...itemData,
                    total,
                    detalles_transacciones,
                    presupuesto_id: presupuesto.id,
                  });
                } else {
                  data[indice].total += total;
                  data[indice].detalles_transacciones = [
                    ...data[indice].detalles_transacciones,
                    ...detalles_transacciones,
                  ];
                }
              }
            }
          });
        });

        for (const datum of data) {
          try {
            const { data } = await TransaccionesServices.store(datum);
            const transaccion = data.datos;

            this.$notify({
              group: 'notifications',
              type: 'success',
              title: 'Éxito',
              text: `Se registró la proyección de ingresos del mes de ${transaccion.mes}`,
              duration: 1500,
              width: 500,
            });
          } catch (error) {
            throw error;
          }
        }
      } catch (error) {
        if (error?.response?.status === 404) {
          this.confirmacionMensaje.mensaje = `No se encuentra presupuesto. Primero debe registrar el presupuesto para la gestión ${this.gestion?.numero}.`;
          this.confirmacionMensaje.mostrado = true;
        }

        if (error?.response?.status === 400 || error?.response?.status === 404) {
          this.$notify({
            group: 'notifications',
            type: 'warn',
            title: 'Error',
            text: `${error?.response?.data?.mensaje || 'Error'}`,
            duration: 1500,
            width: 500,
          });
        }

        window.console.log({ error });
      } finally {
        this.verificarPresupuestosProyectados();
        this.registrandoProyeccionesIngresos = false;
        this.$refs.confirmacionAccionRef.cerrar();
      }
    },
    updateSearchQuery(val) {
      this.$refs.listadoRef.updateSearchQuery(val);
    },
    abrirConfirmacion() {
      this.confirmacion.mensaje = `¿Está seguro que desea registrar la proyección de ingresos para la gestión ${this.gestion?.numero}? Esta acción es irreversible.`;
      this.$refs.confirmacionAccionRef.abrir();
    },
  },
};
</script>

<style scoped>
::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer {
  margin-top: 5px;
}
</style>
